<template>
  <div>
    <div class="toolbar">
      <el-select v-model="query.shiftId" clearable filterable placeholder="班次" style="width:160px">
        <el-option v-for="item in shiftOptions" :key="item.shiftId" :label="item.shiftName" :value="item.shiftId" />
      </el-select>
      <el-date-picker v-model="query.dateFrom" type="date" value-format="yyyy-MM-dd" placeholder="日期从" style="width:140px" />
      <el-date-picker v-model="query.dateTo" type="date" value-format="yyyy-MM-dd" placeholder="到" style="width:140px" />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="reportDate" label="日期" width="120" />
      <el-table-column prop="shiftNumber" label="班次编码" width="120" />
      <el-table-column prop="shiftName" label="班次" min-width="140" />
      <el-table-column prop="trackingCount" label="报工笔数" width="100" align="right" />
      <el-table-column prop="qtyOut" label="产出合计" width="120" align="right" />
      <el-table-column prop="qtyScrap" label="报废合计" width="120" align="right" />
    </el-table>
  </div>
</template>

<script>
import { listShiftOutput } from '../../api/shiftOutput'
import { selectShift } from '../../api/shift'

export default {
  name: 'ShiftOutputPage',
  data() {
    return {
      query: { shiftId: '', dateFrom: '', dateTo: '' },
      list: [], loading: false, shiftOptions: []
    }
  },
  created() {
    selectShift().then(res => { this.shiftOptions = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      listShiftOutput(this.query).then(res => {
        this.list = res.data || []
      }).finally(() => { this.loading = false })
    }
  }
}
</script>
